<template>
    <div class="body_main">
        <div class="body_bd">
            <div class="tab_con flex_c_top">
                <div class="tab_li flex_center tab_li_active">自建模版</div>
<!--                <div class="tab_li flex_center">处方库模版</div>-->
            </div>

            <div class="flex_c_between">
                <!-- 搜索-->
                <el-form class="search_con" :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
                    <el-form-item label="">
                        <el-input style="width: 300px"
                                  v-model="queryParams.preName"
                                  placeholder="请输入处方模版名称或适应病症"
                                  clearable
                        />
                    </el-form-item>
                    <el-form-item label="">
                        <el-select placeholder="处方剂型" v-model="queryParams.billingType" style="width: 200px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="颗粒" value="0"></el-option>
                            <el-option label="饮片" value="1"></el-option>
                            <el-option label="水丸" value="2"></el-option>
                            <el-option label="膏方" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="Search" @click="getlistPrescription">搜索</el-button>
                        <el-button icon="Refresh" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>

                <div class="action_btns">
                    <el-button type="danger" icon="Delete" @click="multipleDeletePrescription()">删除</el-button>
                    <el-button type="primary" icon="Plus" @click="addNewPrescription()">新增</el-button>
                </div>
            </div>


            <!-- 表格-->
            <div class="table_bd_2">
                <el-table
                    ref="multipleTable"
                    v-loading="tableLoading"
                    :data="tableData"
                    :height="tableHeight"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                        label="模版名称">
                        <template #default="scope">
                            <span class="mrr10"><el-tag :type="scope.row.billingType === '0' ? 'primary' : scope.row.billingType === '1' ? 'success' : scope.row.billingType === '2' ? 'warning' : 'danger'"
                                          disable-transitions>{{ scope.row.billingTypeName.substr(0,1) }}
                            </el-tag></span>
                            <span>{{ scope.row.preName === null ? '--': scope.row.preName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="适应病症">
                        <template #default="scope">
                            <span>{{ scope.row.instructions === null ? '--': scope.row.instructions }}</span>
                        </template>
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        label="处方剂型"-->
<!--                        width="100">-->
<!--                        <template #default="scope">-->
<!--                            <el-tag :type="scope.row.billingType === '0' ? 'primary' : scope.row.billingType === '1' ? 'success' : scope.row.billingType === '2' ? 'warning' : 'danger'"-->
<!--                                disable-transitions>{{ scope.row.billingTypeName }}-->
<!--                            </el-tag>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column
                        label="药材">
                        <template #default="scope">
                            <span>{{scope.row.preMedInfo}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建时间">
                        <template #default="scope">
                            <span>{{scope.row.createTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="160">
                        <template #default="scope">
                            <el-tooltip content="编辑" placement="bottom">
                                <el-button type="info" icon="Edit" circle v-on:click="editNewPrescription(scope.$index, tableData)"></el-button>
                            </el-tooltip>
                            <el-tooltip content="删除" placement="bottom">
                                <el-button type="danger" icon="Delete" circle v-on:click="deletePrescription(scope.$index, tableData)"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页-->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>

        </div>
    </div>

    <!--新增自建模版-->
    <el-dialog
        title="新增自建模版"
        v-model="addDialogVisible"
        width="32%">
        <div class="dislog_con">
            <el-form ref="form" :model="prescriptionInfo" label-width="140px">
                <el-form-item label="模版名称" :rules="[{required: true}]">
                    <el-input placeholder="请输入模版名称" v-model="prescriptionInfo.preName"></el-input>
                </el-form-item>
                <el-form-item label="适应病症">
                    <el-input placeholder="请输入模版适应病症" v-model="prescriptionInfo.instructions"></el-input>
                </el-form-item>
                <el-form-item label="处方剂型" :rules="[{required: true}]">
                    <el-radio-group v-model="prescriptionInfo.billingType" @change="changeMedicineType()">
                        <el-radio label="0">颗粒</el-radio>
                        <el-radio label="1">饮片</el-radio>
                        <el-radio label="2">膏方</el-radio>
                        <el-radio label="3">水丸</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="药材列表" :rules="[{required: true}]">
                    <div class="med_list_con">
                        <div class="pre_med_top flex_c_between">
                            <div class="font_gold">共有 {{ prescriptionInfo.docPrescriptionMedicineList.length }} 味药材</div>
                            <el-button type="danger" size="small" icon="Edit" @click="openChooseMedicinalDrawer()">修改药材</el-button>
                        </div>
                        <div class="pre_med_list_con">
                            <div class="med_list_con flex_left_warp" v-if="prescriptionInfo.docPrescriptionMedicineList.length > 0">
                                <div class="pre_med_list_li" v-for="(item, index) in prescriptionInfo.docPrescriptionMedicineList" :key="index">
                                    <span class="font_gold" v-if="item.standard !== null && item.standard !== undefined && item.standard !== '' && prescriptionInfo.billingType === '0' && newRuleOpen">[{{item.standard}}]</span>
                                    <span class="med_li_name">{{item.meName}}</span>
                                    <span class="font_gold" v-if="item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{item.drugProperty}})</span>
                                    <span class="font_gray" v-if="item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && item.decoctionName !== '无'">({{item.decoctionName}})</span>
                                    <span class="font_gray mrl10">{{item.newGCount}}g</span>
                                </div>
                            </div>
                            <el-empty image-size="48" description="暂无药材信息" v-if="prescriptionInfo.docPrescriptionMedicineList.length <= 0">
                                <el-button type="text" @click="openChooseMedicinalDrawer()">添加药材</el-button>
                            </el-empty>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelPrescriptionFun()">取  消</el-button>
                    <el-button type="primary" @click="editPrescriptionFun()">保  存</el-button>
                </span>
        </template>

    </el-dialog>


    <!--编辑自建模版-->
    <el-dialog
        title="编辑自建模版"
        v-model="editDialogVisible"
        width="32%">
        <div class="dislog_con">
            <el-form ref="form" :model="prescriptionInfo" label-width="140px">
                <el-form-item label="模版名称" :rules="[{required: true}]">
                    <el-input placeholder="请输入模版名称" v-model="prescriptionInfo.preName"></el-input>
                </el-form-item>
                <el-form-item label="适应病症">
                    <el-input placeholder="请输入模版适应病症" v-model="prescriptionInfo.instructions"></el-input>
                </el-form-item>
                <el-form-item label="处方剂型" :rules="[{required: true}]">
                    <el-radio-group v-model="prescriptionInfo.billingType" @change="changeMedicineType()">
                        <el-radio label="0">颗粒</el-radio>
                        <el-radio label="1">饮片</el-radio>
                        <el-radio label="2">膏方</el-radio>
                        <el-radio label="3">水丸</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="药材列表" :rules="[{required: true}]">
                    <div class="med_list_con">
                        <div class="pre_med_top flex_c_between">
                            <div class="font_gold">共有 {{ prescriptionInfo.docPrescriptionMedicineList.length }} 味药材</div>
                            <el-button type="danger" size="small" icon="Edit" @click="openChooseMedicinalDrawer()">修改药材</el-button>
                        </div>
                        <div class="pre_med_list_con">
                            <div class="med_list_con flex_left_warp" v-if="prescriptionInfo.docPrescriptionMedicineList.length > 0">
                                <div class="pre_med_list_li" v-for="(item, index) in prescriptionInfo.docPrescriptionMedicineList" :key="index">
                                    <span class="font_gold" v-if="item.standard !== null && item.standard !== undefined && item.standard !== '' && prescriptionInfo.billingType === '0' && newRuleOpen">[{{item.standard}}]</span>
                                    <span class="med_li_name">{{item.meName}}</span>
                                    <span class="font_gold" v-if="item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{item.drugProperty}})</span>
                                    <span class="font_gray" v-if="item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && item.decoctionName !== '无'">({{item.decoctionName}})</span>
                                    <span class="font_gray mrl10">{{item.newGCount}}g</span>
                                </div>
                            </div>
                            <el-empty image-size="48" description="暂无药材信息" v-if="prescriptionInfo.docPrescriptionMedicineList.length <= 0">
                                <el-button type="text" @click="openChooseMedicinalDrawer()">添加药材</el-button>
                            </el-empty>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelPrescriptionFun()">取  消</el-button>
                    <el-button type="primary" @click="editPrescriptionFun()">保  存</el-button>
                </span>
        </template>

    </el-dialog>




    <!-- 选择药材模版-->
    <el-drawer :with-header="false" v-model="medicinalChooseDrawer" :direction="direction" destroy-on-close
               size="48%" :modal="false"
               style="background: #f5f7fa">
        <div class="drawer_con">
            <div class="drawer_title">
                <span>药材管理</span>
                <el-icon class="drawer_icon" @click="getMedicinalDrawerStatus()">
                    <close-bold/>
                </el-icon>
            </div>
            <div class="medicinal_con">
                <Medicinal :pagename="pagename" @medicinalDrawerStatus="getMedicinalDrawerStatus()"></Medicinal>
            </div>
        </div>
    </el-drawer>



</template>

<script>
import prescription from "@/assets/scripts/prescription/index";

export default prescription;
</script>

<style scoped>

</style>